import React, { useEffect, useState } from "react";
import styles from "../../styles.module.scss";
import PropTypes from "prop-types";
import { useQuery } from "@apollo/client";
import SEARCH_PRACTICE_TEAMS from "../../queries/search_practice_team.graphql";
import logError from "app/lib/log-error";
import { I18n, translate } from "@td/shared_utils";
import { map } from "lodash";
import moment from "moment";

const PracticeTeamItem = ({ name, id, createdAt }) => (
  <tr>
    <td data-testid="practice-team-item-name">
      {name}
    </td>
    <td data-testid="practice-team-item-id">
      {id}
    </td>
    <td data-testid="practice-team-item-created-at">
      {moment(createdAt).format("L")}
    </td>
    <td className="actions">
      <a
        href={Routes.practice_team_path(id)}
        data-testid="practice-team-item-view-action"
      >
        <I18n scope="practice_team.actions" text="view" />
      </a>
      &nbsp;
      <a
        href={Routes.edit_practice_team_path(id)}
        data-testid="practice-team-item-edit-action"
      >
        <I18n scope="practice_team.actions" text="edit" />
      </a>
    </td>
  </tr>
);

const PracticeTeamSearchResults = ({ searchParams, setIsFetching }) => {
  const [teams, setTeams] = useState([]);

  const { loading, error } = useQuery(SEARCH_PRACTICE_TEAMS, {
    variables: {
      params: searchParams,
    },
    onCompleted: (data) => {
      setTeams(
        map(data.practiceTeamSearch.edges, "node")
      );
    },
    onError: (error) => {
      logError({ error }, translate(null, "practice_team.search", "server_error"));
    },
  });

  useEffect(() => {
    setIsFetching(loading);
  }, [loading]);

  if (error) {
    return (
      <div className={styles.updateMessage}>
        <I18n scope="practice_team" text="server_error" />
      </div>
    );
  }

  if (loading) {
    return (
      <div className={styles.updateMessage}>
        <I18n scope="practice_team.actions" text="loading" />
      </div>
    );
  }

  return (
    <React.Fragment>
      {teams.length === 0 ? (
        <div>
          <h3>
            <I18n scope="practice_team" text="search_title" />
          </h3>
          <div
            className="no-results"
            data-testid="practice-team-no-results-message"
          >
            <I18n scope="practice_team.search" text="no_result_found" />
          </div>
        </div>
      ) : (
        <div>
          <h3>
            <I18n scope="practice_team" text="search_title" />
          </h3>
          <table className="person_list providers">
            <thead>
              <tr>
                <th data-testid="practice-team-name-label">
                  <I18n scope="practice_team.fields" text="name" />
                </th>
                <th data-testid="practice-team-id-label">
                  <I18n scope="practice_team.fields" text="id" />
                </th>
                <th data-testid="practice-team-created-at-label">
                  <I18n scope="practice_team.fields" text="created_at" />
                </th>
                <th data-testid="practice-team-actions-label">
                  <I18n scope="practice_team.actions" text="label" />
                </th>
              </tr>
            </thead>
            <tbody>
              {teams.map((team) => <PracticeTeamItem key={team.id} {...team} />)}
            </tbody>
          </table>
        </div>
      )}
    </React.Fragment>
  );
};

PracticeTeamSearchResults.propTypes = {
  searchParams: PropTypes.object.isRequired,
  setIsFetching: PropTypes.func.isRequired,
};

export default PracticeTeamSearchResults;
